/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleIcon32Regular = forwardRef('MoneyCurrencyRubleIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 4a2 2 0 0 0-2 2v11H7a1 1 0 1 0 0 2h3v3H7a1 1 0 1 0 0 2h3v3.5a1 1 0 1 0 2 0V24h7a1 1 0 1 0 0-2h-7v-3h6.5a7.5 7.5 0 0 0 0-15H12Zm6.5 13H12V6h6.5a5.5 5.5 0 1 1 0 11Z" })));
});
